import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const isStandarded: TComputedPropMapper<boolean> = ({ offer: { isStandard } }) => Boolean(isStandard);
